module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2d0",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "intro"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/introduction#intro1"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/introduction#intro1"
    }
  }, [_vm._v("Prayer—It’s Not about You")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/chapter_001#ch_1"
    }
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/chapter_001#ch_1"
    }
  }, [_vm._v("The Problem of Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter_002#ch_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter_002#ch_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cats and Dogs Examine the Model Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter_003#ch_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter_003#ch_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning to Ask Big")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter_004#ch_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter_004#ch_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Purposes of Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter_005#ch_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter_005#ch_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Bless Me Like That!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter_006#ch_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter_006#ch_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beware and Be Aware in Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter_007#ch_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter_007#ch_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Timing of God’s Answers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter_008#ch_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter_008#ch_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why Does God Say No?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "bm1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/backmatter_001#bm_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayers God Can’t Answer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/backmatter_001#bm_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Thoughts from Gerald")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "bm2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/backmatter_002#bm_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Putting the “Super” in Supernatural")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/backmatter_002#bm_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Thoughts from Bob")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "note"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/notes#note1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "author"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/author#author1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0